import { Checkbox, FormGroup, TextArea } from '@blueprintjs/core';
import { Routes } from '@just-in-types';
import * as React from 'react';
import { HandleRouteInput } from '.';
import RouteInput, { RouteInputProps } from './RouteInput';

export const enum SignatureRouteAttribute {
  TakeMugshot = 'takeMugshot',
  WaiverText = 'waiverText',
  WaiverTextEs = 'waiverTextEs',
}

export interface SignatureRouteInputProps {
  label: string;
  onChange: HandleRouteInput;
  route: Routes.SignatureRoute;
  routeName: RouteInputProps['routeName'];
}

class SignatureRouteInput extends React.PureComponent<
  SignatureRouteInputProps
> {
  public handleCheckboxChange = ({
    currentTarget: { checked, name },
  }: React.FormEvent<HTMLInputElement>) => {
    const { onChange, routeName } = this.props;

    onChange(routeName, name as SignatureRouteAttribute, checked);
  };

  public handleTextAreaChange = ({
    currentTarget: { name, value },
  }: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { onChange, routeName } = this.props;

    onChange(routeName, name as SignatureRouteAttribute, value);
  };

  public render() {
    const { label, onChange, route, routeName } = this.props;

    return (
      <RouteInput {...{ label, onChange, route, routeName }}>
        <Checkbox
          checked={route.takeMugshot}
          label="take picture"
          name={SignatureRouteAttribute.TakeMugshot}
          onChange={this.handleCheckboxChange}
        />
        <FormGroup label="waiver text">
          <TextArea
            name={SignatureRouteAttribute.WaiverText}
            onChange={this.handleTextAreaChange}
            value={route.waiverText}
          />
        </FormGroup>
        <FormGroup label="waiver text (spanish) (optional)">
          <TextArea
            name={SignatureRouteAttribute.WaiverTextEs}
            onChange={this.handleTextAreaChange}
            value={route.waiverTextEs}
          />
        </FormGroup>
      </RouteInput>
    );
  }
}

export default SignatureRouteInput;



// WEBPACK FOOTER //
// ./src/components/SiteAdder/SignatureRouteInput.tsx